import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useUsersApi } from "../../../http/users/api";
import ModalDialog from "../../ui/ModalDialog";

type DeleteUserRoleDialogProps = {
  roleId: string;
  userId: string;
  onClose: (success?: boolean) => void;
};

const DeleteUserRoleDialog: FC<DeleteUserRoleDialogProps> = ({ roleId, userId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const usersApi = useUsersApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.userRoles.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            usersApi
              .deleteAdminUserRole(roleId, userId)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => {
                onClose(true);
                dispatch(showSuccessNotification(i18n.t));
              })
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.userRoles.questions.delete}
    </ModalDialog>
  );
};

export default DeleteUserRoleDialog;
